import script from "./OptionInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionInput.vue?vue&type=script&setup=true&lang=ts"

import "./OptionInput.vue?vue&type=style&index=0&id=184b4a23&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184b4a23"]])

export default __exports__